export default __webpack_public_path__ + "static/media/banner-page-iadi.9f262ec1.png";